import * as tokens from '@utmost.co/utmost-design-tokens';

export type TokenColor =
  | (keyof typeof tokens & `palette${string}`)
  | (keyof typeof tokens & `color${string}`)
  | (keyof typeof tokens & `state${string}`)
  | (keyof typeof tokens & `surface${string}`);

export { tokens };

/**
 * Maps a given color string or token color to its corresponding token value.
 * If the token color is not defined or not found in tokens, it defaults to `tokens.colorOnSurface`.
 * If the color is a direct color value (not a token), it is returned as is.
 * @param color
 */
export function getTokenColor(color: string | TokenColor | undefined): string {
  if (!color) return tokens.colorOnSurface;
  if (
    color.startsWith('palette') ||
    color.startsWith('color') ||
    color.startsWith('state') ||
    color.startsWith('surface')
  ) {
    return color in tokens ? tokens[color as TokenColor] : tokens.colorOnSurface;
  }
  return color;
}
